// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__4egWY","img":"Logo_img__LdRhM"};